import { render, staticRenderFns } from "./reviews-component.vue?vue&type=template&id=e93fb3ac&lang=html"
import script from "./reviews-component.vue?vue&type=script&lang=js"
export * from "./reviews-component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports